/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpRegistriesListRegistries } from "../funcs/mcpRegistriesListRegistries.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRegistriesResponseBody } from "../models/components/listregistriesresponsebody.js";
import {
  ListMCPRegistriesRequest,
  ListMCPRegistriesSecurity,
} from "../models/operations/listmcpregistries.js";
import { unwrapAsync } from "../types/fp.js";
export type ListMCPRegistriesQueryData = ListRegistriesResponseBody;

export function prefetchListMCPRegistries(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMCPRegistriesRequest | undefined,
  security?: ListMCPRegistriesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListMCPRegistriesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListMCPRegistriesQuery(
  client$: GramCore,
  request?: ListMCPRegistriesRequest | undefined,
  security?: ListMCPRegistriesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListMCPRegistriesQueryData>;
} {
  return {
    queryKey: queryKeyListMCPRegistries({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listMCPRegistriesQueryFn(
      ctx,
    ): Promise<ListMCPRegistriesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpRegistriesListRegistries(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListMCPRegistries(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpRegistries", "listRegistries", parameters];
}
